import { useSelector } from "react-redux";
import { emrAccidentHeaders, emrAccidentValues, emrDiagnosisHeaders, emrItemsHeaders, emrPatientDetailsList, fomrateEMRItemsData, fomrateSupportingInfoData, formatDiagnosisData, formatmmunizationData, immunizationHeader, supportingInfoHeaders, VitalSignsRecordList, vitalSignsValues } from "../../constants/EmrContants";
import { handlePrintData } from "../../utils/PrintData";
import { renderIfNotEmpty } from "../../utils/RenderIfNotEmpty";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { PrintIcon } from "../../utils/TableActionIcons";
import { EmrReportTable, InfoTable, RowText } from "./Prescription";
import ChaiReportHead from "../../shared/ChaiReportHeader";
import ChaiReportFooter from "../../shared/ChaiReportFooter";
import CardHeading from "../../shared/CardHeading";
function EmrDetails({ emrData }) {
    const printRef = useRef(null);
    const { t, i18n } = useTranslation();
    const lang = i18n?.language;
    const { buisnessInfo } = useSelector((state) => state?.auth);

    return (
        <div className="">
            <div
                className={`icon-bg-container absolute top-[21px] ${lang == "ar" ? "left-[70px]" : "right-[70px]"
                    }`}
                onClick={() =>
                    handlePrintData(printRef.current?.innerHTML, t("Prescription"))
                }
            >
                <PrintIcon iconSize="20" />
            </div>
            <div className="print-container" ref={printRef}>
                <div className="flex flex-col gap-2">
                    <ChaiReportHead reportName={t("Medical Report")} />
                    <InfoTable
                        title={`${t("Patient Information")} / معلومات المريض`}
                        rows={emrPatientDetailsList(emrData, t)}
                    />

                    <div className="border border-gray-300 rounded">
                        <div className="bg-gray-100 p-2 rounded">
                            <CardHeading
                                textClassName="!text-[14px]"
                                title={t("vital_signs")}
                            />
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 py-2 w-full gap-y-2">
                            {VitalSignsRecordList(
                                vitalSignsValues(emrData?.vital_signs),
                                t
                            )?.map((data, index) => (
                                <RowText title={data?.label} value={data?.text} key={index} />
                            ))}
                        </div>
                    </div>

                    <div className="border border-gray-300 rounded mt-2">
                        <div className="bg-gray-100 p-2 rounded">
                            <CardHeading
                                textClassName="!text-[14px]"
                                title={t("Diagnosis")}
                            />
                        </div>
                        <EmrReportTable
                            headers={emrDiagnosisHeaders}
                            values={formatDiagnosisData(emrData?.diagnosisArr)}
                        />
                    </div>
                    {renderIfNotEmpty(
                        emrData?.items,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading textClassName="!text-[14px]" title={t("Items")} />
                            </div>
                            <EmrReportTable
                                headers={emrItemsHeaders}
                                values={fomrateEMRItemsData(emrData?.items)}
                            />
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.supportingInfos,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("supporting_infos")}
                                />
                            </div>
                            <EmrReportTable
                                headers={supportingInfoHeaders}
                                values={fomrateSupportingInfoData(emrData?.supportingInfos)}
                            />
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.accident,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("Accident Information")}
                                />
                            </div>
                            <EmrReportTable
                                headers={emrAccidentHeaders}
                                values={emrAccidentValues([emrData?.accident])}
                            />
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.immunization,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("immunization")}
                                />
                            </div>
                            <EmrReportTable
                                headers={immunizationHeader}
                                values={formatmmunizationData([emrData?.immunization])}
                            />
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.chief_complaints?.value,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("chief_complaints")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            emrData?.medical_assessments?.chief_complaints?.value ||
                                            "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.family_history,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("family_history")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            emrData?.medical_assessments?.family_history || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.past_history,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("past_history")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: emrData?.medical_assessments?.past_history || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.physical_assessment,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("physical_assessment")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            emrData?.medical_assessments?.physical_assessment || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.significient_signs,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("significant_signs")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            emrData?.medical_assessments?.significient_signs || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.medical_assessments?.other_conditions,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("other_condition")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            emrData?.medical_assessments?.other_conditions || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.doctor_notes?.progress_notes,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("progress_notes")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: emrData?.doctor_notes?.progress_notes || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {renderIfNotEmpty(
                        emrData?.doctor_notes?.procedure_notes,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("procedure_notes")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: emrData?.doctor_notes?.procedure_notes || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {/* {renderIfNotEmpty(
            emrData?.doctor_notes?.nursing_notes,
            <div className="border border-gray-300 rounded mt-2">
              <div className="bg-gray-100 p-2 rounded">
                <CardHeading
                  textClassName="!text-[14px]"
                  title={t("nursing_notes")}
                />
              </div>
              <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                <span
                  dangerouslySetInnerHTML={{
                    __html: emrData?.doctor_notes?.nursing_notes || "__",
                  }}
                ></span>
              </div>
            </div>
          )} */}
                    {renderIfNotEmpty(
                        emrData?.doctor_notes?.history_notes,
                        <div className="border border-gray-300 rounded mt-2">
                            <div className="bg-gray-100 p-2 rounded">
                                <CardHeading
                                    textClassName="!text-[14px]"
                                    title={t("history_and_physical")}
                                />
                            </div>
                            <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: emrData?.doctor_notes?.history_notes || "__",
                                    }}
                                ></span>
                            </div>
                        </div>
                    )}
                    {/* {renderIfNotEmpty(
            emrData?.doctor_notes?.consult_notes,
            <div className="border border-gray-300 rounded mt-2">
              <div className="bg-gray-100 p-2 rounded">
                <CardHeading
                  textClassName="!text-[14px]"
                  title={t("consult_notes")}
                />
              </div>
              <div className=" py-2 w-full px-2 text-12-dark !font-normal">
                <span
                  dangerouslySetInnerHTML={{
                    __html: emrData?.doctor_notes?.consult_notes || "__",
                  }}
                ></span>
              </div>
            </div>
          )} */}
                    {/* {emrData?.growth_chart &&
                        Object.keys(emrData.growth_chart).length > 0 ? (
                        <div className="mt-2">
                            <RCPCHChart
                                height={200}
                                reference={emrData?.growth_chart?.growthChartData?.reference}
                                measurementMethod={
                                    emrData?.growth_chart?.growthChartData?.measurementMethod
                                }
                                sex={emrData?.growth_chart?.growthChartData?.gender}
                                title={
                                    emrData?.growth_chart?.growthChartData?.title ||
                                    t("Growth Chart")
                                }
                                measurements={emrData?.growth_chart?.chartMeasurements}
                                midParentalHeightData={[]}
                                theme={emrData?.growth_chart?.growthChartData?.theme}
                                enableZoom={false}
                                chartType={emrData?.growth_chart?.growthChartData?.chartType}
                                enableExport={
                                    emrData?.growth_chart?.growthChartData?.enableExport
                                }
                                exportChartCallback={() => { }}
                                clinicianFocus={
                                    emrData?.growth_chart?.growthChartData?.clinicianFocus
                                }
                            />
                        </div>
                    ) : (
                        ""
                    )} */}
                    <div className="flex gap-8 w-full justify-end mt-8 print:mt-16">
                        <div className="text-center">
                            <p className="text-[10px] mt-1">{t("Practitioner Stamp")}</p>
                            <img
                                src={emrData?.practitioner?.stamp}
                                alt={t("stamp")}
                                className="w-[7rem] h-[7rem] border-gray-200"
                            />
                        </div>
                        <div className="text-center">
                            <p className="text-[10px] mt-1">{t("Practitioner Signature")}</p>
                            <img
                                src={emrData?.practitioner?.signature}
                                alt={t("signature")}
                                className="w-[7rem] h-[7rem] border-gray-200"
                            />
                        </div>
                    </div>
                    <ChaiReportFooter />
                </div>
            </div>
        </div>
    );
}

export default EmrDetails;